import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
  esp: (
    `
    <p class="mb-3">
      La nombro, kiun oni povas atribui nek al pozitivaj, nek al negativaj, ambaŭokaze estas nulo.
    </p>
    `
  )
}

const itemName = {
  esp: 'La leĝo de nombroj'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;